export default __webpack_public_path__ + "static/media/6.98ca9df7.jpg";